/* eslint-disable filenames/match-regex */
export const getSubscriberStyle = (theme) => (
  <style jsx="true">
    {`
      .subtitle,
      .legal-text > div,
      .center-align {
        color: #fff;
      }

      .popeye-modal--light .subtitle,
      .popeye-modal--light .legal-text > div,
      .popeye-modal--light .center-align {
        color: #000;
      }

      .subtitle {
        margin-top: -15px;
        margin-bottom: 30px;
        text-align: center;
      }
      .input-container {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        height: 0;
        width: 0;
        z-index: -1;
      }
      .text-label {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        height: 0;
        width: 0;
        z-index: -1;
      }
      .header-bar {
        width: 100%;
        margin-bottom: 20px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
      }
      .header-bar .close {
        position: absolute;
        top: 5px;
        opacity: 0.6;
        font-size: 1.3rem;

        font-family: Arial, Helvetica, sans-serif;
        font-weight: lighter;
        color: gray;
        text-size-adjust: 70%;
        font-size: 18px;
      }

      .subscriber-wrapper .logo-link {
        cursor: pointer;
        pointer-events: none;
      }

      .form-group {
        margin: 0;
        padding: 0 0 1rem;
        position: relative;
        z-index: 99;
      }

      .mobile-text {
        margin-bottom: 20px;
      }

      .subscribe-dropdown-container,
      .email-input-container {
        position: relative;
        margin-bottom: 20px;
      }
      .subscriber-wrapper .icon-container {
        position: absolute;
        left: 0;
        top: 0;
        margin: 6px 0 0 12px;
        font-size: 24px;
      }

      .subscribe-dropdown,
      .field__email {
        width: 100%;
        font-size: 16px;
        color: #4d4d4d;
        border-radius: 6px;
        border: 1px solid #c7c7c7;
        appearance: none;
        -webkit-appearance: none;
        background-color: #ffffff;
        margin: 0;
        padding-left: 40px;
        height: 46px;
      }

      .subscribe-dropdown::-ms-expand {
        display: none;
      }

      .subscribe-dropdown {
        word-wrap: normal;
        appearance: none;
      }

      .subscribe-dropdown-container::after {
        content: '';
        pointer-events: none;
        position: absolute;
        top: 20px;
        right: 10px;
        bottom: auto;
        left: auto;
        width: 0;
        height: 0;
        border-left: 6px solid rgba(0, 0, 0, 0);
        border-right: 6px solid rgba(0, 0, 0, 0);
        border-top: 6px solid #c7c7c7;
      }

      .center-align {
        text-align: center;
      }

      .justify {
        text-align: justify;
        font-size: 14px;
        line-height: 1.4rem;
      }

      .login-modal {
        border: 1px solid ${theme.colors.primary};
        color: ${theme.colors.lightboxbuttoncolor};
        background: ${theme.colors.lightboxbuttonbackground};
        font-size: 18px;
        margin: 0;
        padding: 0;
        max-height: 38px;
        margin-top: 13px;
        text-transform: ${theme.text.lightbox};
        padding: 5px 10px;
        border-radius: 4px;
        border-bottom: ${theme.colors.lightboxbuttonborderbottom};
      }

      .submit {
        width: 100%;
        font-size: 24px;
        text-transform: ${theme.text.lightbox};
        background: ${theme.colors.lightboxsubmitbuttonbackground};
        border-bottom: ${theme.colors.lightboxsubmitbuttonborder};
        color: #ffffff;
        border-radius: 5px;
        border: 0;
        padding: 10px;
      }
      .green-input select,
      .green-input input {
        border-color: ${theme.colors.lightboxgreenborders};
      }
      .grey-input input {
        border-color: ${theme.colors.lightboxgrayborders};
      }

      .animate {
        transition-property: all;
        transition-duration: 0.3s;
        transition-timing-function: ease-in-out;
      }
      .alert__error {
        padding: 10px;
        text-align: center;
        border: 1px solid #af1512;
        background: #f49a99;
        color: #af1512;
        margin-bottom: 10px;
      }

      .legal-text {
        padding-bottom: 10px;
        line-height: 1.4;
        font-weight: 100;
      }

      .lightbox-modal .legal-text a {
        color: #000;
        text-decoration: underline;
      }

      .lightbox-modal .legal-text a:hover {
        color: #1b94e4;
        text-decoration: none;
      }

      .modal-backdrop {
        z-index: 9999;
      }

      .subscriber-wrapper {
        padding: 0;
      }

      @media (min-width: ${theme.breakpoints.mdUp}) {
        .subtitle {
          font-size: 1.6rem;
          text-align: left;
        }

        .subtitle,
        .legal-text > div,
        .center-align {
          color: #000;
        }

        .alert__error {
          padding: 6px;
        }

        .visible-xs {
          display: none;
        }

        .subscriber-wrapper {
          position: relative;
          max-width: 340px;
          background-image: none;
          background-color: #ffffff;
          border-radius: 6px;
          color: black;
          outline: 0;
          padding: 16px 20px;
          height: auto;
          border: ${theme.colors.lightboxcontainerborder};
          box-shadow: ${theme.colors.lightboxcontainerboxshadow};
          border: 1px solid #ffffff;
          height: 100%;
        }

        @media (min-width: ${theme.breakpoints.lgUp}) {
          .subscriber-wrapper {
            max-width: 370px;
            min-height: 580px;
            height: fit-content;
          }
        }
      }
    `}
  </style>
);
